import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import sanitizeHtml from 'utils/sanitizeHtml'

const propTypes = {
  html: PropTypes.string,
  className: PropTypes.string,
  as: PropTypes.elementType,
}
const defaultProps = {
  html: '',
  className: undefined,
  as: 'div',
}

function SafeHtml({ html, className, as: Component }) {
  const cleanHtml = sanitizeHtml(html)

  if (!cleanHtml) return null

  return (
    <Component
      className={classNames('safe-html', className)}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  )
}

SafeHtml.propTypes = propTypes
SafeHtml.defaultProps = defaultProps

export default SafeHtml
